import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  imageTitle: {
    color: '#515B6A',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginTop: 0,
  },
  image: {
    maxWidth: '100%',
    cursor: 'pointer',
  },
  selectImageWrapper: {
    '& [data-small-image]': {
      display: 'none',
    },
  },
  previewContainer: {
    height: 'fit-content',
    border: 'dashed #DCDEE5 2px',
    minHeight: 186,
  },
}), { name: 'DocumentInstruction' });

export default useStyles;
